import * as types from "./types";

const initialState = {
  list: [],
  meta: {
    currentPage: 1,
    count: 0,
    pages: 1,
  },
};

const companyLoyalApplicants = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_LOYAL_APPLICANTS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    default:
      return state;
  }
};

export default companyLoyalApplicants;
